package com.huanshankeji.compose.foundation.layout

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet
import org.jetbrains.compose.web.css.Style

@Composable
internal fun AddKobwebComposeStyleSheet() =
    Style(KobwebComposeStyleSheet)
